<template>
  <v-dialog v-model="show" max-width="950px">
    <form-toolbar title="Edit Extra Lift"
                  :onSubmitClick="submitForm"
                  :onCloseClick="onCloseClick" />
    <v-card class="pa-1">
      <v-container>
        <ValidationObserver ref="form">
          <v-form class="mt-1">
            <v-row>
              <v-col cols="12" md="2">
                <ValidationProvider name="Unit Id"
                                    rules="required"
                                    v-slot="{ errors }">
                  <v-text-field v-model="extraLift.unitId"
                                :error-messages="errors"
                                label="Unit Id" />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="3">
                <ValidationProvider name="Description"
                                    rules="required"
                                    v-slot="{ errors }">
                  <v-text-field v-model="extraLift.description"
                                :error-messages="errors"
                                label="Description" />
                </ValidationProvider>
              </v-col>
              <v-col col="12" md="1">
                <ValidationProvider name="Length"
                                    :rules="{
                                      required: true,
                                      min_value: 0.1
                                    }"
                                    v-slot="{ errors }">
                  <v-text-field v-model="extraLift.length"
                                type="number"
                                :error-messages="errors"
                                label="Length" />
                </ValidationProvider>
              </v-col>
              <v-col col="12" md="1">
                <ValidationProvider name="Width"
                                    :rules="{
                                      required: true,
                                      min_value:0.1,
                                    }"
                                    v-slot="{ errors }">
                  <v-text-field v-model="extraLift.width"
                                type="number"
                                :error-messages="errors"
                                label="Width" />
                </ValidationProvider>
              </v-col>
              <v-col col="12" md="2">
                <ValidationProvider name="Quantity"
                                    :rules="{
                                      required: true,
                                      min_value:1,
                                    }"
                                    v-slot="{ errors }">
                  <v-text-field v-model="extraLift.quantity"
                                type="number"
                                :error-messages="errors"
                                label="Quantity" />
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="extraLift.stackLevel"
                          true-value="0"
                          false-value="1"
                          label="Stacked">
                </v-switch>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-container>
    </v-card>
  </v-dialog>
</template>


<script>
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import FormToolbar from '../ui/FormToolbar.vue';
  import { min_value } from 'vee-validate/dist/rules';

  extend('min_value', {
    ...min_value,
    message: `Must be at least {min}`
  });

  export default {
    name: 'EditExtraLiftDialog',
    components: {
      ValidationProvider,
      ValidationObserver,
      FormToolbar,
    },
    props: {
      extraLift: Object,
      value: Boolean,
      onCloseClick: Function,
      onSubmitClick: Function
    },
    methods: {
      submitForm() {
        this.$refs.form.validate()
          .then((isValid) => {
            if (isValid) this.onSubmitClick();
          });
      },
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    watch: {
      show(val) {
        if (!val) this.onCloseClick(this.activity);
      },
    },
  };
</script>
